export default __webpack_public_path__ + "static/media/CNo.41-3.83c63a91.jpg";